export enum Difficulty {
    WorldBoss = 0,
    DungeonNormal = 1,
    DungeonHeroic = 2,
    RaidLegacy10Normal = 3,
    RaidLegacy10Heroic = 5,
    RaidLegacy25Normal = 4,
    RaidLegacy25Heroic = 6,
    RaidLegacyLookingForRaid = 7,
    DungeonMythicKeystone = 8,
    RaidLegacy40 = 9,
    RaidNormal = 14,
    RaidHeroic = 15,
    RaidMythic = 16,
    RaidLookingForRaid = 17,
    RaidEvent = 18,
    DungeonMythic = 23,
    DungeonTimewalking = 24,
    RaidTimewalking = 33,
    RaidMythicFlex = 233,
    RaidWorld = 250,
}
